/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react'
import { Form } from 'semantic-ui-react'
import Select from 'react-select'
import _ from 'lodash'

export default class ItemField extends React.PureComponent {
  render() {
    const { itemKeys, items, onChange, isClearable= true, isMulti= true} = this.props

    const value = _.reduce(
      items,
      (result, item, key) => {
        const option = {
          label: item.name,
          value: key,
        }

        if (itemKeys.includes(key)) {
          result.existedValue.push(option)
        }

        result.options.push(option)

        return result
      },
      { existedValue: [], options: [] }
    )

    return (
      <Form.Field required>
        <label>Items</label>
        <Select
          menuPosition="fixed"
          required
          isMulti={isMulti}
          isClearable={isClearable}
          isSearchable
          isRtl={false}
          name="items"
          value={value.existedValue}
          isDisabled={false}
          className="basic-single"
          classNamePrefix="Choose items"
          onChange={onChange}
          options={value.options}
        />
      </Form.Field>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/restaurants/fields/itemField.js